export default "__VITE_ASSET__UuyDIyFF__"